import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Observable} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LogService} from "../../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {Timestamp} from "firebase/firestore";
import {MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-add-education-log',
  templateUrl: './add-education-log.component.html',
  styleUrls: ['./add-education-log.component.scss']
})
export class AddEducationLogComponent implements OnInit {
  form: FormGroup;
  centreControl  = new FormControl(null,Validators.required)
  sessionTypes:string[]=["Rapport Building","Baseline Assessment","Regular Study",'Intermediate Assessment','Discharge Assessment','Group Session']
  // topicsCovered$:Observable<any>
  mCentres$:Observable<Centre[]>
  floors:string[]=[]
  userName:string
  constructor(private fb: FormBuilder,
              readonly mCentreService:CentreService,
              private  readonly mDialog:MatDialog,
              private  readonly mSnackbar:MatSnackBar,
              private mDialogRef:MatDialogRef<AddEducationLogComponent>,
              readonly mLogService:LogService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              readonly mDatabase:AngularFireDatabase){
    const userData = JSON.parse(localStorage.getItem('userData')!)
    this.userName = userData?.userName
    this.mCentres$ = this.mCentreService.getAllCentres()
    // this.topicsCovered$ = this.mDatabase.list('types/Topics Covered').valueChanges()
    if(data==undefined) {
      this.form = this.fb.group({
        id: [''],
        conductedBy: [this.userName, Validators.required],
        centreName: ['', Validators.required],
        centreCode: ['', [Validators.required]],
        sessionType: ['', Validators.required],
        // topicsCovered: ['', Validators.required],
        floor:['',Validators.required],
        sessionDate: ['', Validators.required],
        createdAt: [new Date(), Validators.required],
        status: ['Pending', Validators.required],
      });
    }else{
      this.form = this.fb.group({
        id: [data.id, Validators.required],
        conductedBy: [data.conductedBy, Validators.required],
        centreName: [data.centreName, Validators.required],
        centreCode: [data.centreCode, [Validators.required]],
        sessionType: [data.sessionType, Validators.required],
        floor:[data.floor,Validators.required],

        // topicsCovered: [data.topicsCovered, Validators.required],
        sessionDate: [(data.sessionDate as unknown as Timestamp).toDate(), Validators.required],
        createdAt: [new Date(), Validators.required],
        status: [data.status, Validators.required],
      });
    }
  }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.form.valid) {
      // Submit form data
      console.log(this.form.value);
      if(this.data==null) this.mLogService.addEducationLog(this.form.value).then(res=>{

        this.mSnackbar.open('Log added successfully',"",{
          panelClass:'success',
          duration:3000
        })
        this.mDialogRef.close()
      })
    } else if(this.data!=null) {
      this.mLogService.updateEducationLog(this.form.value).then(res=>{
        this.mSnackbar.open('Log added successfully',"",{
          panelClass:'success',
          duration:3000
        })
        this.mDialogRef.close()
      })
      console.error('Form is invalid');
    }
  }

  onCentreSelect($event: MatSelectChange) {
    this.floors=[]
    let c   = $event.value as Centre
    this.form.get('centreCode')?.setValue(c.centreCode)
    this.form.get('centreName')?.setValue(c.centreName)
    if(c?.floorsArray?.length==1){
      this.floors.push('Ground Floor')
    } else if(c.floorsArray?.length==2){
      this.floors.push('Ground Floor')
      this.floors.push('1st Floor')
    }else if(c?.floorsArray?.length==3){
      this.floors.push('Ground Floor')
      this.floors.push('1st Floor')
      this.floors.push('2nd Floor')
    }else if(c?.floorsArray?.length==4){
      this.floors.push('Ground Floor')
      this.floors.push('1st Floor')
      this.floors.push('2nd Floor')
      this.floors.push('3rd Floor')
    }else if(c?.floorsArray?.length==5){
      this.floors.push('Ground Floor')
      this.floors.push('1st Floor')
      this.floors.push('2nd Floor')
      this.floors.push('3rd Floor')
      this.floors.push('4th Floor')
    }
  }
}
